<script setup lang="ts">
  import type { ServicesSectionContent } from '@/models/service';
  import type { PropType } from 'vue';

  defineProps({
    serviceSectionContent: {
      type: Object as PropType<ServicesSectionContent>,
      required: true
    }
  });

  const emits = defineEmits(['contactClick']);

  const onContactClick = () => {
    //navigateTo(localePath('chat'));
    emits('contactClick');
  };
</script>

<template>
  <div class="service-card-base custom-service-card">
    <video
      class="custom-service-card__video-mobile"
      :autoplay="true"
      :loop="true"
      :muted="true"
      :controls="false"
      :playsinline="true">
      <source
        src="@/assets/videos/usecase-bg-mobile.mp4"
        type="video/mp4" />
    </video>
    <video
      class="custom-service-card__video-desktop"
      :autoplay="true"
      :loop="true"
      :muted="true"
      :controls="false"
      :playsinline="true">
      <source
        src="@/assets/videos/usecase-bg-desktop.mp4"
        type="video/mp4" />
    </video>
    <div class="custom-service-card__wrapper">
      <div class="custom-service-card__icon">
        <img
          src="@/assets/images/plus-circle.svg"
          alt="icon" />
      </div>
      <div>
        <h2 class="custom-service-card__title">
          <div v-html="serviceSectionContent.contactTitle"></div>
        </h2>
        <p class="custom-service-card__description">
          {{ serviceSectionContent.contactDescription }}
        </p>
      </div>
      <a
        class="custom-service-card__link"
        @click.prevent="onContactClick()">
        {{ serviceSectionContent.contactButtonText }}
      </a>
    </div>
  </div>
</template>
